import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const CookiesPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-slate-900">
            <span className="text-xl font-bold">AutoFlow</span>
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors text-sm"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver al inicio
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <article className="bg-white rounded-xl shadow-sm p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2">
            Politica de Cookies
          </h1>
          <p className="text-slate-500 mb-8 pb-8 border-b">
            <strong>AutoFlow</strong> | Ultima actualizacion: diciembre 2025
          </p>

          <div className="prose prose-slate max-w-none">
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">
              1. Que son las cookies
            </h2>
            <p className="text-slate-600 mb-4 leading-relaxed">
              Las cookies son pequenos archivos de texto que se almacenan en tu
              dispositivo (computadora, tablet o celular) cuando visitas un sitio
              web. Permiten que el sitio recuerde tus acciones y preferencias
              durante un periodo de tiempo.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">
              2. Cookies que utilizamos
            </h2>

            <h3 className="text-lg font-medium text-slate-800 mt-6 mb-2">
              2.1 Cookies esenciales (obligatorias)
            </h3>
            <p className="text-slate-600 mb-3 leading-relaxed">
              Son necesarias para el funcionamiento basico del sitio. Sin ellas,
              no podrias iniciar sesion ni usar las funciones principales.
            </p>
            <div className="overflow-x-auto mb-6">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="border-b border-slate-200">
                    <th className="text-left py-2 pr-4 font-semibold text-slate-700">Cookie</th>
                    <th className="text-left py-2 pr-4 font-semibold text-slate-700">Proposito</th>
                    <th className="text-left py-2 font-semibold text-slate-700">Duracion</th>
                  </tr>
                </thead>
                <tbody className="text-slate-600">
                  <tr className="border-b border-slate-100">
                    <td className="py-2 pr-4 font-mono text-xs">access_token</td>
                    <td className="py-2 pr-4">Autenticacion de sesion</td>
                    <td className="py-2">7 dias</td>
                  </tr>
                  <tr className="border-b border-slate-100">
                    <td className="py-2 pr-4 font-mono text-xs">refresh_token</td>
                    <td className="py-2 pr-4">Renovacion de sesion</td>
                    <td className="py-2">7 dias</td>
                  </tr>
                  <tr className="border-b border-slate-100">
                    <td className="py-2 pr-4 font-mono text-xs">autoflow_cookie_consent</td>
                    <td className="py-2 pr-4">Preferencia de cookies</td>
                    <td className="py-2">Permanente</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="text-lg font-medium text-slate-800 mt-6 mb-2">
              2.2 Cookies opcionales
            </h3>
            <p className="text-slate-600 mb-4 leading-relaxed">
              Actualmente AutoFlow <strong>no utiliza</strong> cookies de
              analitica, publicidad ni de terceros. Si en el futuro se
              implementan, este documento sera actualizado y se te pedira
              consentimiento nuevamente.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">
              3. Como gestionar tus cookies
            </h2>
            <p className="text-slate-600 mb-4 leading-relaxed">
              Podes gestionar o eliminar las cookies desde la configuracion de tu
              navegador. Ten en cuenta que deshabilitar las cookies esenciales
              puede afectar el funcionamiento del sitio.
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-1 mb-4">
              <li>
                <strong>Chrome:</strong> Configuracion {'>'} Privacidad y seguridad {'>'} Cookies
              </li>
              <li>
                <strong>Firefox:</strong> Opciones {'>'} Privacidad {'>'} Cookies
              </li>
              <li>
                <strong>Safari:</strong> Preferencias {'>'} Privacidad {'>'} Cookies
              </li>
              <li>
                <strong>Edge:</strong> Configuracion {'>'} Cookies y permisos del sitio
              </li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">
              4. Base legal
            </h2>
            <p className="text-slate-600 mb-4 leading-relaxed">
              Las cookies esenciales se utilizan bajo el interes legitimo de
              proporcionar el servicio. Las cookies opcionales (cuando existan)
              requieren tu consentimiento explicito conforme al RGPD y la Ley
              25.326 de Proteccion de Datos Personales de Argentina.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">
              5. Contacto
            </h2>
            <p className="text-slate-600 mb-4 leading-relaxed">
              Si tenes preguntas sobre nuestra politica de cookies, contactanos
              por WhatsApp o a traves del formulario en nuestra pagina principal.
            </p>
          </div>

          <div className="mt-10 pt-8 border-t border-slate-200 flex flex-wrap gap-4 text-sm">
            <Link
              to="/privacy"
              className="text-blue-600 hover:text-blue-800 transition-colors"
              data-testid="cookies-privacy-link"
            >
              Politica de Privacidad
            </Link>
            <Link
              to="/terms"
              className="text-blue-600 hover:text-blue-800 transition-colors"
              data-testid="cookies-terms-link"
            >
              Terminos y Condiciones
            </Link>
          </div>
        </article>
      </main>
    </div>
  );
};

export default CookiesPage;
